<template>
  <div class="legal wide-container">
    <h1 class="legal__title">
      <Lang by-key="cookie-policy-title" />
    </h1>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-0-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-0-body-00" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-0-body-01" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="cookie-policy-0-body-02" /></li>
        <li><Lang by-key="cookie-policy-0-body-03" /></li>
      </ul>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-0-body-04" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="cookie-policy-0-body-05" /></li>
        <li><Lang by-key="cookie-policy-0-body-06" /></li>
        <li><Lang by-key="cookie-policy-0-body-07" /></li>
        <li><Lang by-key="cookie-policy-0-body-08" /></li>
        <li><Lang by-key="cookie-policy-0-body-09" /></li>
        <li><Lang by-key="cookie-policy-0-body-10" /></li>
        <li><Lang by-key="cookie-policy-0-body-11" /></li>
      </ul>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-0-body-12" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-1-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-00" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-01" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-02" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-03" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-04" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-05" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-06" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-07" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-08" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-09" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-10" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-1-body-11" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-2-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-3" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-4" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-5" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-6" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-7" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-2-body-8" />
      </p>
    </div>

    <div class="legal__block">
      <p class="legal__block__body highlight">
        <Lang by-key="cookie-policy-3-header" />
      </p>
    </div>

    <div class="cookies-table">
      <div>PHPSESSID</div>
      <div>
        <Lang by-key="cookie-policy-ctext-00" />
      </div>
      <div>
        <Lang by-key="cookie-policy-label-own" />/<Lang by-key="cookie-policy-label-session" />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccess" /></div>

      <div>Cookie_notice_accepted</div>
      <div><Lang by-key="cookie-policy-ctext-01" /></div>
      <div><Lang by-key="cookie-policy-label-own" /> / 1 <Lang by-key="year" /></div>
      <div><Lang by-key="cookie-policy-label-onaccess" /></div>

      <div>_ga</div>
      <div><Lang by-key="cookie-policy-ctext-02" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 2 <Lang
          by-key="year"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_ga_#/td></div>
      <div><Lang by-key="cookie-policy-ctext-03" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" />/ 2 <Lang
          by-key="year"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_gid</div>
      <div><Lang by-key="cookie-policy-ctext-04" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 24 <Lang
          by-key="hour"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_gcl_au</div>
      <div><Lang by-key="cookie-policy-ctext-05" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 3 <Lang
          by-key="month"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_bkrmk</div>
      <div><Lang by-key="cookie-policy-ctext-06" /></div>
      <div><Lang by-key="cookie-policy-label-external" /> / <Lang by-key="cookie-policy-label-session" /></div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_bkrmku</div>
      <div><Lang by-key="cookie-policy-ctext-06" /></div>
      <div><Lang by-key="cookie-policy-label-external" /> / <Lang by-key="cookie-policy-label-session" /></div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>fs_uid</div>
      <div><Lang by-key="cookie-policy-ctext-07" /></div>
      <div><Lang by-key="cookie-policy-label-external" /> / 1 <Lang by-key="year" /></div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>fs_lua</div>
      <div><Lang by-key="cookie-policy-ctext-08" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 30 <Lang
          by-key="min"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>_fbp</div>
      <div><Lang by-key="cookie-policy-ctext-09" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 3 <Lang
          by-key="month"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>cp_id_27e91</div>
      <div><Lang by-key="cookie-policy-ctext-10" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 30 <Lang
          by-key="day"
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>cp-impression-added-forcp_id_</div>
      <div><Lang by-key="cookie-policy-ctext-11" /></div>
      <div>
        <Lang by-key="cookie-policy-label-external" /> / 30 <Lang
          by-key="day"
          plural
        />
      </div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>

      <div>Klaro</div>
      <div><Lang by-key="cookie-policy-ctext-12" /></div>
      <div><Lang by-key="cookie-policy-label-external" /> / 1 <Lang by-key="year" /></div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>
    </div>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-3-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-3-body-1" />
      </p>
      <p class="legal__block__body highlight">
        <Lang by-key="cookie-policy-3-body-2" />
      </p>
    </div>

    <div class="cookies-table-external">
      <div class="highlight">
        <Lang by-key="cookie-policy-label-owne" />
      </div>
      <div class="highlight">
        <Lang by-key="cookie-policy-label-name" />
      </div>
      <div class="highlight">
        <Lang by-key="cookie-policy-label-when" />
      </div>
      <div class="highlight">
        <Lang by-key="cookie-policy-label-desc" />
      </div>
      <div class="highlight">
        <Lang by-key="cookie-policy-label-dura" />
      </div>
      <div class="highlight">
        <Lang by-key="cookie-policy-label-info" />
      </div>

      <div>google.com/es</div>
      <div>NID</div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>
      <div><Lang by-key="cookie-policy-google-service-0" /></div>
      <div><Lang by-key="cookie-policy-google-it-depends" /></div>
      <div>
        <SplNuxtLink
          to="https://policies.google.com/technologies/cookies#types-of-cookies"
          no-lang
        >
          <SplButton variant="link">
            <Lang
              by-key="click-here"
              no-lang
              capitalize-first
            />
          </SplButton>
        </SplNuxtLink>
      </div>

      <div>google.com/es</div>
      <div>NID - CONSENT - SOCS - AEC</div>
      <div><Lang by-key="cookie-policy-label-onaccept" /></div>
      <div><Lang by-key="cookie-policy-google-service-1" /></div>
      <div><Lang by-key="cookie-policy-google-duration" /></div>
      <div>
        <Lang by-key="cookie-policy-google-uncontrol" />
        <SplNuxtLink
          class="ml-text"
          to="https://policies.google.com/technologies/cookies#types-of-cookies"
          no-lang
        >
          <SplButton variant="link">
            <Lang
              by-key="click-here"
              no-lang
            />
          </SplButton>
        </SplNuxtLink>
      </div>

      <div>google.com/es</div>
      <div>__Secure-ENID fb</div>
      <div />
      <div><Lang by-key="cookie-policy-google-service-2" /></div>
      <div>
        13 <Lang
          by-key="month"
          plural
        />
      </div>
      <div>
        <Lang by-key="cookie-policy-google-uncontrol" />
        <SplNuxtLink
          class="ml-text"
          to="https://policies.google.com/technologies/cookies#types-of-cookies"
          no-lang
        >
          <SplButton variant="link">
            <Lang
              by-key="click-here"
              no-lang
            />
          </SplButton>
        </SplNuxtLink>
      </div>
    </div>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-3-body-3" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-4-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-4-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-4-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-4-body-2" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-5-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-3" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="cookie-policy-5-body-4" />
      </p>

      <div class="legal__block__table">
        <div class="cell-header">
          Internet Explorer:
        </div>
        <div class="cell">
          <SplNuxtLink
            to="http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies"
            no-lang
          >
            <SplButton variant="link">
              http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies
            </SplButton>
          </SplNuxtLink>
        </div>
        <div class="cell-header">
          Firefox:
        </div>
        <div class="cell">
          <SplNuxtLink
            to="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-web"
            no-lang
          >
            <SplButton variant="link">
              https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-web
            </SplButton>
          </SplNuxtLink>
        </div>
        <div class="cell-header">
          Safari:
        </div>
        <div class="cell">
          <SplNuxtLink
            to="http://support.apple.com/kb/HT1677?viewlocale=es_ES"
            no-lang
          >
            <SplButton variant="link">
              http://support.apple.com/kb/HT1677?viewlocale=es_ES
            </SplButton>
          </SplNuxtLink>
        </div>
        <div class="cell-header">
          Chrome:
        </div>
        <div class="cell">
          <SplNuxtLink
            to="https://support.google.com/accounts/answer/61416?hl=es"
            no-lang
          >
            <SplButton variant="link">
              https://support.google.com/accounts/answer/61416?hl=es
            </SplButton>
          </SplNuxtLink>
        </div>
        <div class="cell-header">
          Opera:
        </div>
        <div class="cell">
          <SplNuxtLink
            to="http://help.opera.com/Windows/11.50/es-ES/cookies.html"
            no-lang
          >
            <SplButton variant="link">
              http://help.opera.com/Windows/11.50/es-ES/cookies.html
            </SplButton>
          </SplNuxtLink>
        </div>
      </div>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-5" />
      </p>

      <p class="legal__block__body highlight">
        <Lang by-key="cookie-policy-5-body-6" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-7" />
      </p>

      <ul class="legal__block__list">
        <li>
          <SplNuxtLink
            to="http://www.ghostery.com"
            no-lang
          >
            <SplButton variant="link">
              http://www.ghostery.com
            </SplButton>
          </SplNuxtLink>
        </li>
        <li>
          <SplNuxtLink
            to="http://www.youronlinechoices.com/es/"
            no-lang
          >
            <SplButton variant="link">
              http://www.youronlinechoices.com/es/
            </SplButton>
          </SplNuxtLink>
        </li>
      </ul>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-5-body-8" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-6-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-6-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-7-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-7-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-7-body-1" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-8-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-8-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-8-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-8-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="cookie-policy-8-body-3" />

        <SplNuxtLink
          class="ml-text"
          to="https://policies.google.com/technologies/cookies?hl=es"
          no-lang
        >
          <SplButton variant="link">
            https://policies.google.com/technologies/cookies
          </SplButton>
        </SplNuxtLink>
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="cookie-policy-9-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="cookie-policy-9-body-0" />
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
    SplButton,
  },
  setup() {
    const builder = HeadMetaBuilder.create()
    builder.withTitleAndMetaTitle('Política de Cookies | Spalopia.com')

    useHead(builder.get())

    return {}
  }
})
</script>

<style lang="scss" scoped>
@import url('./legal.scss');
.cookies-table, .cookies-table-external {
  @apply grid;
  div {
    @apply border-1;
    @apply p-2;
  }

  div.highlight {
    @apply font-bold;
  }
}

.cookies-table {
  @apply grid-cols-4;
}

.cookies-table-external {
  @apply grid-cols-6;
}
</style>
